import React, { useState } from 'react';
import { FaGithub, FaBehance } from 'react-icons/fa';
import './Projects.css';

function Projects() {
  const [filter, setFilter] = useState('All');

  const projects = [
    {
      id: 1,
      title: "Hospital Management System",
      description: "Developed a hospital management system to streamline patient registration, appointment scheduling, and doctor management with an intuitive front-end interface.",
      technologies: ["C#"],
      category: "Academic",
      github: null,
      behance: null
    },
    {
      id: 2,
      title: "Resort Management System",
      description: "Created a customized resort management system for a specific resort in Nepal to manage bookings, room availability, and customer information.",
      technologies: ["HTML", "CSS", "JavaScript", "React"],
      category: "Academic",
      github: "https://github.com/smriti-mulmi/HMS",
      behance: null
    },
    {
      id: 3,
      title: "Nepal Tourism Recommender System",
      description: "Final year project: Built an intelligent tourism recommendation system to help travelers discover the best destinations in Nepal based on their preferences.",
      technologies: ["React", "Vite", "Flask", "Python", "SQLite"],
      category: "Academic",
      github: "https://github.com/NeeluDeshar/Final-year-project---Nepal-Tourism-Recommendation-System",
      behance: null
    },
    {
      id: 4,
      title: "Digital Agency UI Design",
      description: "Designed a user-friendly mobile app prototype to connect farmers with local buyers.",
      technologies: ["Figma"],
      category: "Design",
      github: null,
      behance: "https://www.behance.net/nirjaladeshar98"
    },
    {
      id: 5,
      title: "Graphic Design Portfolio",
      description: "Created posters, social media graphics, and digital art pieces as part of personal and academic growth in graphic design.",
      technologies: ["Adobe Photoshop", "Canva"],
      category: "Design",
      github: null,
      behance: "https://www.behance.net/gallery/226103965/Learning-by-Designing"
    },
    {
      id: 6,
      title: "Weather Card",
      description: "Designed a responsive and interactive weather information card UI.",
      technologies: ["UI/UX", "Figma"],
      category: "UI/UX",
      github: null,
      behance: "https://www.behance.net/gallery/235211971/Weather-Card"
    },
    {
      id: 7,
      title: "Rating Model",
      description: "Created an intuitive rating system interface for user feedback.",
      technologies: ["UI/UX", "Figma"],
      category: "UI/UX",
      github: null,
      behance: "https://www.behance.net/gallery/235219349/Rating-Model"
    },
    {
      id: 8,
      title: "Pet Adoption Homepage",
      description: "Developed a user-friendly homepage for a pet adoption platform.",
      technologies: ["UI/UX", "Figma"],
      category: "UI/UX",
      github: null,
      behance: "https://www.behance.net/gallery/235338133/Pet-Adoption-Website"
    },
    {
      id: 9,
      title: "Remote Work Productivity Dashboard",
      description: "Designed a dashboard UI to monitor productivity metrics for remote workers.",
      technologies: ["UI/UX", "Figma"],
      category: "UI/UX",
      github: null,
      behance: "https://www.behance.net/gallery/235869845/Remote-Work-Productivity-Dashboard"
    }
  ];

  const categories = ['All', 'Academic', 'Design', 'UI/UX'];
  
  const filteredProjects = filter === 'All' 
    ? projects 
    : projects.filter(project => project.category === filter);

  return (
    <div className="page projects">
      <div className="container">
        <h1>My Projects</h1>
        <p className="projects-description">
          Here are some of the projects I've worked on, showcasing my skills in development, design, and problem-solving.
        </p>
        
        <div className="filter-buttons">
          {categories.map(category => (
            <button
              key={category}
              className={`filter-btn ${filter === category ? 'active' : ''}`}
              onClick={() => setFilter(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {filteredProjects.length > 0 ? (
          <div className="projects-grid">
            {filteredProjects.map(project => (
              <div key={project.id} className="project-card">
                <div className="project-category">{project.category}</div>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="project-tech">
                  {project.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag">{tech}</span>
                  ))}
                </div>
                <div className="project-links">
                  {project.github && (
                    <a href={project.github} target="_blank" rel="noopener noreferrer" className="project-link github-link">
                      <FaGithub /> GitHub
                    </a>
                  )}
                  {project.behance && (
                    <a href={project.behance} target="_blank" rel="noopener noreferrer" className="project-link behance-link">
                      <FaBehance /> Behance
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-projects">No projects available in this category.</p>
        )}
      </div>
    </div>
  );
}

export default Projects;
